import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import HomePanelFull from './HomePanelFull';
import HomePanelNarrow from './HomePanelNarrow';

const HomePanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: HomePanelFull, narrow: HomePanelNarrow }}
  />
);

export default HomePanel;
